"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScreenInfos = exports.useScreenOrientation = exports.useWindowOrientation = void 0;
const react_1 = require("react");
const react_native_1 = require("react-native");
const base_ui_responsive_breakpoints_1 = require("@unboared/base-ui.responsive.breakpoints");
const useWindowOrientation = () => {
    const [windowInfos, setWindowInfos] = (0, react_1.useState)(react_native_1.Dimensions.get('window'));
    (0, react_1.useEffect)(() => {
        const onChange = (result) => {
            setWindowInfos(result.window);
        };
        react_native_1.Dimensions.addEventListener('change', onChange);
        return () => react_native_1.Dimensions.removeEventListener('change', onChange);
    }, []);
    return Object.assign(Object.assign({}, windowInfos), { type: (0, base_ui_responsive_breakpoints_1.getDeviceType)(windowInfos.width), isPortrait: windowInfos.height > windowInfos.width, isLandscape: windowInfos.height <= windowInfos.width });
};
exports.useWindowOrientation = useWindowOrientation;
const useScreenOrientation = () => {
    const [screenInfos, setScreenInfos] = (0, react_1.useState)(react_native_1.Dimensions.get('screen'));
    (0, react_1.useEffect)(() => {
        const onChange = (result) => {
            setScreenInfos(result.screen);
        };
        react_native_1.Dimensions.addEventListener('change', onChange);
        return () => react_native_1.Dimensions.removeEventListener('change', onChange);
    }, []);
    return Object.assign(Object.assign({}, screenInfos), { type: (0, base_ui_responsive_breakpoints_1.getDeviceType)(screenInfos.width), isPortrait: screenInfos.height > screenInfos.width, isLandscape: screenInfos.height <= screenInfos.width });
};
exports.useScreenOrientation = useScreenOrientation;
exports.useScreenInfos = react_native_1.Platform.select({
    native: exports.useScreenOrientation,
    default: exports.useWindowOrientation
});
//# sourceMappingURL=orientation.js.map